import styled from "@mui/material/styles/styled";
import Box from "../Box";
const AvatarBox = styled(Box)((props) => {
  const { onClick, size, borderRadius, background, textColor } = props;
  return {
    position: "relative",
    overflow: "visible",
    textAlign: "center",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: `${size}px`,
    height: `${size}px`,
    color: textColor,
    borderRadius: `${borderRadius}px`,
    cursor: onClick ? "pointer" : "default",
    background
  };
});
const PlaceholderImg = styled("img")((props) => {
  const { borderRadius } = props;
  return {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    marginBottom: 0,
    borderRadius: `${borderRadius}px`
  };
});
const SlotBox = styled(Box)(() => {
  return {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
});
const StartTopSlotBox = styled(SlotBox)((props) => {
  const { slotOffset, slotSize } = props;
  return {
    left: `-${slotOffset}px`,
    top: `-${slotOffset}px`,
    minWidth: `${slotSize}px`,
    minHeight: `${slotSize}px`
  };
});
const StartBottomSlotBox = styled(SlotBox)((props) => {
  const { slotOffset, slotSize } = props;
  return {
    left: `-${slotOffset}px`,
    bottom: `-${slotOffset}px`,
    minWidth: `${slotSize}px`,
    minHeight: `${slotSize}px`
  };
});
const EndTopSlotBox = styled(SlotBox)((props) => {
  const { slotOffset, slotSize } = props;
  return {
    right: `-${slotOffset}px`,
    top: `-${slotOffset}px`,
    minWidth: `${slotSize}px`,
    minHeight: `${slotSize}px`
  };
});
const EndBottomSlotBox = styled(SlotBox)((props) => {
  const { slotOffset, slotSize } = props;
  return {
    right: `-${slotOffset}px`,
    bottom: `-${slotOffset}px`,
    minWidth: `${slotSize}px`,
    minHeight: `${slotSize}px`
  };
});
const BadgeSlotBox = styled(Box)((props) => {
  const { border, borderColor, borderRadius } = props;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: `${borderRadius}px`,
    border: `${border}px solid ${borderColor}`,
    position: "relative",
    overflow: "visible"
  };
});
const OverlaySlotIcon = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  zIndex: 1,
  pointerEvents: "none"
}));
const SlotAvatarBox = styled(Box)(() => {
  return {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none"
  };
});
const IconSlot = styled(Box)((props) => {
  const { boxSize, boxBg, border } = props;
  return {
    width: `${boxSize}px`,
    height: `${boxSize}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    border: `${border}px solid ${boxBg}`,
    position: "relative",
    overflow: "visible"
  };
});
const AvatarSlot = styled(Box)((props) => {
  const { boxBg, border, borderRadius, boxSize, borderColor } = props;
  return {
    width: `${boxSize}px`,
    height: `${boxSize}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: `${borderRadius}px`,
    background: boxBg,
    border: `${border}px solid ${borderColor}`,
    overflow: "visible"
  };
});
const AvatarImageContainer = styled("div")((props) => {
  const { borderRadius, isLoaded } = props;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: `${borderRadius}px`,
    overflow: "hidden",
    opacity: isLoaded ? 1 : 0
  };
});
const AvatarSlotImageContainer = styled("div")((props) => {
  const { borderSize, isLoaded } = props;
  return {
    position: "absolute",
    top: `${borderSize}px`,
    left: `${borderSize}px`,
    width: `calc(100% - ${borderSize * 2}px)`,
    height: `calc(100% - ${borderSize * 2}px)`,
    zIndex: 2,
    opacity: isLoaded ? 1 : 0
  };
});
export {
  AvatarBox,
  AvatarImageContainer,
  AvatarSlot,
  AvatarSlotImageContainer,
  BadgeSlotBox,
  EndBottomSlotBox,
  EndTopSlotBox,
  IconSlot,
  OverlaySlotIcon,
  PlaceholderImg,
  SlotAvatarBox,
  StartBottomSlotBox,
  StartTopSlotBox
};
